<template>
  <div class="wh100 container" layout="column center-center">
    <div>

      <div class="card" style="padding: 3rem;">
        <headbar/>
        <div class="form-group">
          <input ref="email" class="form-control" type="email" placeholder="Email" :disabled="loading">
        </div>
        <div class="form-group">
          <input ref="password" class="form-control" type="password" placeholder="Password" :disabled="loading">
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-secondary" @click="checkLogin" :disabled="loading">
            Login
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Backend from '@/Backend';
  import Headbar from "./Headbar";

  export default {
    components: {Headbar},
    name: "login",
    data() {
      return {
        loading: false
      }
    },
    methods: {
      checkLogin() {
        this.loading = true;
        const email = this.$refs.email.value;
        const password = this.$refs.password.value;

        Backend.instance.login(email, password)
          .then(() => {

            this.loading = false;
            this.$router.push({path:'/dashboard'});
          })
          .catch(() => {
            this.loading = false;
          })
      }
    }
  }
</script>

<style scoped>
  .container {
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue